import { Component } from '@angular/core';

import { AgRendererComponent } from 'ag-grid-angular';
//import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-checkbox-renderer',
    templateUrl: './checkbox-renderer.component.html',
    styleUrls: ['./checkbox-renderer.component.scss'],
    standalone: false
})
export class CheckboxRendererComponent implements AgRendererComponent {
    params: any;
    _isChecked: boolean = false;
    _isVisible: boolean = true;
    _isEnabled: boolean = true;
    renderAsYesNo: boolean = false;
    private _textRenderOptions: CustomTextRenderOptions = {
        trueOption: "Yes",
        falseOption: "No"
    }
    get customRenderOptions(): CustomTextRenderOptions {
        return this._textRenderOptions;
    }

    constructor() {
    }

    agInit(params): void {
        this.params = params;
        //First set _isVisible based on isVisibleField property
        this._isVisible = params.data[params.isVisibleField] != null && params.data[params.isVisibleField] != undefined ? params.data[params.isVisibleField] : true;
        //now check if a method was provided, if so override _isVisible
        if (params.isVisible != null && params.isVisible != undefined)
            this._isVisible = this.params.isVisible(this.params);

        this._isChecked = params.data[params.field] != null && params.data[params.field] != undefined ? params.data[params.field] : false;
        if (params.isEnabled != null) {
            this._isEnabled = this.params.isEnabled(this.params);
        }
        if (params.renderAsYesNo != null) {
            this.renderAsYesNo = params.renderAsYesNo;
            if (params.textRenderOptions != null) {
                this._textRenderOptions = params.textRenderOptions;
            }
        }

        params.eGridCell?.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                this.onClick();
            }
        });
    }

    getYesNo(): string {
        return (this._isChecked) ? this.customRenderOptions.trueOption : this.customRenderOptions.falseOption;
    }

    refresh(params: any): boolean {
        return false;
    }

    onClick(): void {
        if (this._isEnabled) {
            this.params.action(this.params.data);
            this._isChecked = !this._isChecked;
        }
    }
}

export type CellAction = (params) => void;

export interface CustomTextRenderOptions {
    trueOption: string,
    falseOption: string
}